<template>
  <v-dialog v-model="showDialog" :max-width="800" :persistent="loading">
    <v-card class="pa-0">
      <div class="text-right d-flex text-white bg-black pa-2">
        <div class="text-left pa-0">
          {{ title }}
        </div>
        <v-icon
          class="ml-auto"
          size="20"
          color="#fff"
          :disabled="loading"
          @click="showDialog = false"
        >
          mdi-close-circle
        </v-icon>
      </div>
      <v-simple-table dense>
        <template #default>
          <thead class="">
            <tr class="custom-table-bordered">
              <th class="text-center text-body-1 text-dark" colspan="7">
                <b>{{ title }}</b>
              </th>
            </tr>
            <tr class="custom-table-bordered">
              <td />
              <td class="text-center table-heading text-body-2">
                Último trimestre cerrado
              </td>
              <td class="text-center table-heading text-body-2">
                Trimestre Actual
              </td>
            </tr>
          </thead>
          <tbody v-if="!loading" class="custom-table-bordered">
            <tr>
              <td class="table-heading small text-body-2">
                Porcentaje de pagos VIA IEL
              </td>
              <td class="table-heading text-body-2">
                {{
                  formatFloat(data.previousQuarter.ielPaymentPercentage ?? 0, 2)
                }}
                %
              </td>
              <td class="table-heading text-body-2">
                {{
                  formatFloat(data.currentQuarter.ielPaymentPercentage ?? 0, 2)
                }}
                %
              </td>
            </tr>
            <tr>
              <td class="table-heading small text-body-2">Pagos VIA IEL</td>
              <td class="table-heading text-body-2">
                {{
                  formatNumber(
                    data.previousQuarter.ielPaymentAmount ?? 0,
                    '$',
                    0
                  )
                }}
              </td>
              <td class="table-heading text-body-2">
                {{
                  formatNumber(
                    data.currentQuarter.ielPaymentAmount ?? 0,
                    '$',
                    0
                  )
                }}
              </td>
            </tr>

            <tr>
              <td class="table-heading small text-body-2">Total de pagos</td>
              <td class="table-heading text-body-2">
                {{
                  formatNumber(data.previousQuarter.totalPayments ?? 0, '$', 0)
                }}
              </td>
              <td class="table-heading text-body-2">
                {{
                  formatNumber(data.currentQuarter.totalPayments ?? 0, '$', 0)
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <v-progress-linear class="mt-3" indeterminate color="teal" />
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <alert-prominent v-if="errors" :text="errors" type="error" />
      <v-btn class="ma-2" :disabled="loading" @click="showDialog = false">
        Cerrar
      </v-btn>
    </v-card>
  </v-dialog>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import numbersFormats from '@/mixins/numbersFormats';
  import AlertProminent from '@/components/AlertProminent.vue';
  export default {
    name: 'CustomerPaymentTypes',
    components: { AlertProminent },
    mixins: [numbersFormats],
    props: {
      title: {
        type: String,
        default: 'Detalle de pagos',
      },
      value: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        default: {
          previousQuarter: {
            ielPaymentPercentage: 0,
            ielPaymentAmount: 0,
            totalPayments: 0,
          },
          currentQuarter: {
            ielPaymentPercentage: 0,
            ielPaymentAmount: 0,
            totalPayments: 0,
          },
        },
      },
      errors: {
        type: String,
        default: '',
      },
    },
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
<style scoped>
  .yellow-tr {
    background: #ffd75e 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    border: 1px solid #dde1e6;
    opacity: 1;
  }
</style>
